import messaging from '@react-native-firebase/messaging';

export function subscribeToBackgroundNotifications() {
  messaging().setBackgroundMessageHandler(async _remoteMessage => {
    // TODO: https://8seatsdev.atlassian.net/browse/HZN-1459
  });
}
